export const NAVIGATION_MENU_BG_CLASS = '!bg-gray-100/95 dark:bg-gray-900/90';
